import {SxProps, Theme} from '@mui/material';

export const containerSx: SxProps<Theme> = {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
};
